import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  XCircleIcon,
  ClockIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/solid';
import clsx from 'clsx';

export type StatusType =
  | 'active'
  | 'past_due'
  | 'canceled'
  | 'trialing'
  | 'paused'
  | 'incomplete'
  | 'paid'
  | 'open'
  | 'void'
  | 'uncollectible'
  | 'draft';

interface StatusBadgeProps {
  status: StatusType;
  text?: string;
  className?: string;
}

const config: Record<string, { bg: string; text: string; icon: typeof CheckCircleIcon; label: string }> = {
  active: { bg: 'bg-green-500/10', text: 'text-green-400', icon: CheckCircleIcon, label: 'Active' },
  paid: { bg: 'bg-green-500/10', text: 'text-green-400', icon: CheckCircleIcon, label: 'Paid' },
  past_due: { bg: 'bg-amber-500/10', text: 'text-amber-400', icon: ExclamationCircleIcon, label: 'Past Due' },
  open: { bg: 'bg-amber-500/10', text: 'text-amber-400', icon: ClockIcon, label: 'Open' },
  canceled: { bg: 'bg-red-500/10', text: 'text-red-400', icon: XCircleIcon, label: 'Canceled' },
  void: { bg: 'bg-slate-500/10', text: 'text-slate-400', icon: DocumentTextIcon, label: 'Void' },
  uncollectible: { bg: 'bg-red-500/10', text: 'text-red-400', icon: XCircleIcon, label: 'Uncollectible' },
  trialing: { bg: 'bg-blue-500/10', text: 'text-blue-400', icon: ClockIcon, label: 'Trialing' },
  paused: { bg: 'bg-slate-500/10', text: 'text-slate-400', icon: ClockIcon, label: 'Paused' },
  incomplete: { bg: 'bg-amber-500/10', text: 'text-amber-400', icon: ExclamationCircleIcon, label: 'Incomplete' },
  draft: { bg: 'bg-slate-500/10', text: 'text-slate-400', icon: DocumentTextIcon, label: 'Draft' },
};

export function StatusBadge({ status, text, className }: StatusBadgeProps) {
  const current = config[status] || config.active;
  const Icon = current.icon;

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-sm font-medium border border-current/10',
        current.bg,
        current.text,
        className,
      )}
    >
      <Icon className="w-3.5 h-3.5" />
      {text || current.label}
    </span>
  );
}
